module.exports = __webpack_public_path__ + "media/images/example_import_smart-b9b3b90d7ef52f596e8e4ddaee8533a2.png";